import {MODAL_FETCHED} from "../types";

export const modalFetched = modal => ({
    type: MODAL_FETCHED,
    modal
});

export const openModal = (type, options) => (dispatch, getState) => {
    const body = document.getElementsByTagName("BODY")[0];
    let modal;
    body.classList.add("modal");

    switch (type) {
        case 'video':
            modal = {
                'activeClass': type,
                'videoId': options
            };
            break;
        case 'member':
            modal = {
                'activeClass': type
            };
            break;
        case 'search':
            modal = {
                'activeClass': type
            };
            break;
        case 'profile':
            modal = {
                'activeClass': type,
                'profile': options
            };
            break;
        case 'cta':
            modal = {
                'activeClass': type,
                'cta': options
            };
            break;
        default:
            modal = {
                'activeClass': false
            };
            break;
    }
    dispatch(modalFetched(modal));
};

export const closeModal = () => (dispatch, getState) => {
    const body = document.getElementsByTagName("BODY")[0];
    const activeModal = document.getElementsByTagName("iframe")[0];
    const modal = {
        'activeClass': false
    }
    dispatch(modalFetched(modal));
    activeModal.removeAttribute("src");
    body.classList.remove("modal");
};








// WEBPACK FOOTER //
// ./src/actions/modal.js